/*= ===========================================================================
  Init micro modal for size guide and find in store
============================================================================== */

window?.MicroModal.init({
  openTrigger: 'data-micromodal-trigger',
  closeTrigger: 'data-micromodal-close',
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: false,
  awaitOpenAnimation: false,
  awaitCloseAnimation: false,
  debugMode: true,
  onShow: (modal) => {
    document.body.classList.add('modal-open');

    // set modal max-height manually to fix 100vh issue
    // document.documentElement.clientHeight > window.innerHeight for iOS
    const modalContainer = modal.querySelector('.modal__container');
    modalContainer.style.maxHeight = `${document.documentElement.clientHeight - 80}px`;

    const query = 'only screen and (max-width: 768px)';
    const isUnderTabletWidth = window.matchMedia(query).matches;

    if (isUnderTabletWidth) {
      modalContainer.style.maxWidth = `${document.documentElement.clientWidth - 30}px`;
    }
  },
  onClose: () => document.body.classList.remove('modal-open'),
});

const currentRoute = {
  storeLocator: window.location.pathname.includes('/store-locator'),
  pdp: window.location.pathname.includes('/products/'),
  giftCard: window.location.pathname.includes('/gift-card'),
  newsBlog: window.location.pathname.includes('/blogs/news'),
};

/*= ===========================================================================
  Store locator page - stockist plugin mods
============================================================================== */

const classes = {
  locationBtn: 'custom-location-button',
  findBtn: 'custom-find-button',
};

function buildPanel(allNotes) {
  allNotes.forEach((container) => {
    const content = container.innerHTML;
    const newContent = `<div class="details-tab">More Details</div><div class="details-content">${content}</div>`;
    container.classList.add('details-built');
    container.innerHTML = newContent;
    const detailsTab = container.querySelector('.details-tab');
    detailsTab.addEventListener('click', function () {
      this.classList.toggle('details-btn-active');
      this.nextSibling.classList.toggle('details-active');
    });
  });
}

function customisePins(allPins) {
  const svg = '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 26"><path d="m17.548 16.398-7.104 8.648-7.112-8.645-.145-.193-.001-.002a9.72 9.72 0 0 1-2.02-5.956c0-2.55.982-4.99 2.721-6.784a9.134 9.134 0 0 1 6.557-2.8A9.134 9.134 0 0 1 17 3.467c1.74 1.794 2.722 4.235 2.722 6.784 0 2.078-.652 4.1-1.876 5.753l-.002.002-.008.011-.03.041-.097.129-.103.137-.04.052-.012.017-.005.005a.008.008 0 0 1 0 .001Z" stroke="#010203"/></svg>';
  const svgActive = '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 26"><path d="m17.548 16.398-7.104 8.648-7.112-8.645-.145-.193-.001-.002a9.72 9.72 0 0 1-2.02-5.956c0-2.55.982-4.99 2.721-6.784a9.134 9.134 0 0 1 6.557-2.8A9.134 9.134 0 0 1 17 3.467c1.74 1.794 2.722 4.235 2.722 6.784 0 2.078-.652 4.1-1.876 5.753l-.002.002-.008.011-.03.041-.097.129-.103.137-.04.052-.012.017-.005.005a.008.008 0 0 1 0 .001Z" fill="#010203" stroke="#010203"/></svg>';

  allPins.forEach((pin, idx) => {
    pin.classList.add('details-built');
    pin.insertAdjacentHTML(
      'afterend',
      `
        <div class='map-pin-text'>${idx + 1}</div>
        <div class='map-pin-svg'>${svg}</div>
        <div class='map-pin-svg-active'>${svgActive}</div>
      `,
    );
  });
}

function customisePhoneNumbers(allPhoneNumbers) {
  allPhoneNumbers.forEach((phoneNumber) => {
    phoneNumber.classList.add('details-built');
    phoneNumber.classList.remove('stockist-feature-color');
  });
}

function attachStoreLocatorAppObserver() {
  const StoreLocatorAppObserver = new MutationObserver((mutations, mutationInstance) => {
    const searchBar = document.querySelector('.stockist-query-entry');
    const searchInput = searchBar?.querySelector('input');
    const allNotes = document.querySelectorAll(
      '.stockist-side-panel .stockist-result-notes:not(.details-built)',
    );
    const allPhoneNumbers = document.querySelectorAll(
      '.stockist-side-panel .stockist-result-phone > a:not(.details-built)',
    );
    const allPins = document.querySelectorAll(
      '.stockist-side-panel .stockist-icon-marker:not(.details-built)',
    );

    const shouldModifyStockist = searchInput && allNotes.length && allPhoneNumbers && allPins.length;

    // const distances = document.querySelectorAll(
    //   '.stockist-result-distance',
    // );
    // if (distances) distances.forEach((distance) => distance.remove());

    if (shouldModifyStockist) {
      geocodeUserQuery({ searchInput, type: 'storeLocator' });
      customisePins(allPins);
      buildPanel(allNotes);
      customisePhoneNumbers(allPhoneNumbers);

      mutationInstance.disconnect();
    }
  });

  StoreLocatorAppObserver.observe(document, {
    childList: true,
    subtree: true,
  });
}

if (currentRoute.storeLocator) {
  attachStoreLocatorAppObserver();
}

/*= ===========================================================================
  PDP pages, afterpay mods
============================================================================== */

if (currentRoute.pdp) {
  const afterpayObserver = new MutationObserver((mutations, mutationInstance) => {
    const afterpayRendered = document.querySelector('.afterpay-paragraph');
    if (afterpayRendered) {
      const paymentText = document.querySelector('.afterpay-text1');
      const fortnightlyText = document.querySelector('.afterpay-text2');
      const afterpayLink = document.querySelector('.afterpay-link');
      const afterpayInstalments = document.querySelector('.afterpay-instalments');

      const newAfterpayInstalmentsText = afterpayInstalments.textContent.slice(0, -3);

      paymentText.textContent = '4 payments of ';
      afterpayInstalments.textContent = newAfterpayInstalmentsText;
      fortnightlyText.remove();
      afterpayLink.remove();
      afterpayRendered.style.display = 'inline-flex';
      afterpayRendered.style.marginTop = '0';

      mutationInstance.disconnect();
    }
  });

  afterpayObserver.observe(document, {
    childList: true,
    subtree: true,
  });
}

/*= ===========================================================================
  Blog pages - load more button
============================================================================== */

if (currentRoute.newsBlog) {
  const blogLoaderBtn = document.getElementById('blog-load-more');
  const targetDOM = document.querySelector('.blog-container');
  const nextUrl = blogLoaderBtn.getAttribute('href');
  let activeReq = false;

  blogLoaderBtn.addEventListener('click', (e) => {
    e.preventDefault();

    if (activeReq === false) {
      activeReq = true;
      blogLoaderBtn.classList.add('disabled');
      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBlogs = doc.querySelector('.blog-container');
          const newUrl = doc.getElementById('blog-load-more').getAttribute('href');
          [...newBlogs.children].forEach((blogItem) => {
            targetDOM.append(blogItem);
          });

          if (newUrl === '') {
            blogLoaderBtn.remove();
          }

          blogLoaderBtn.classList.remove('disabled');
          activeReq = false;
        })
        .catch((error) => {
          console.warn(error);
        });
    }
  });
}

/*= ===========================================================================
  PDP find in store
============================================================================== */

function attachInventoryMessages() {
  const storeMessages = JSON.parse(document.getElementById('find-in-store-messages').textContent);
  // console.info('Store Messages: ', storeMessages);
  const allResults = document.querySelectorAll('.stockist-list-result');

  allResults.forEach((result) => {
    const currentMarkup = result.innerHTML;

    if (!currentMarkup.includes('result-wrap')) {
      const wrappedMarkup = `<div class='result-wrap'>${currentMarkup}</div>`;
      result.innerHTML = `
      <div class='result-logo'></div>
      ${wrappedMarkup}
      <div class='result-quantity'>
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>`;
    }
  });

  if (allResults && window.ap21Stores) {
    allResults.forEach((result) => {
      const customField = result.querySelector('.stockist-result-custom-field');
      const quantityField = result.querySelector('.result-quantity');

      let customFieldAP21Name;
      if (customField) {
        customFieldAP21Name = customField.childNodes[1].textContent;

        const matchingStore = window.ap21Stores.find(
          (store) => customFieldAP21Name.trim() === store.name.trim(),
        );

        if (!matchingStore) {
          // no matching AP21 store with the Stockist app's AP21Name custom field
          quantityField.innerHTML = `${storeMessages.itemsUnavailableMsg}`;
        } else if (matchingStore.stock === 0) {
          quantityField.innerHtml = `${storeMessages.itemsUnavailableMsg}`;
        } else if (matchingStore.stock >= 2) {
          quantityField.innerHTML = `${storeMessages.itemsAvailableMsg}`;
        } else {
          quantityField.innerHTML = `${storeMessages.callStoreMsg}`;
        }
      } else {
        // no ap21Name custom field value entered for the Stockist apps location
        quantityField.innerHTML = storeMessages.itemsUnavailableMsg;
      }
    });
  }
}

const resetResults = ({ searchInput, searchTerm, type }) => {
  const hiddenStockistSearchButton = document.querySelector('.stockist-search-button button');
  searchInput.value = searchTerm;
  hiddenStockistSearchButton.click();

  if (type === 'pdp') {
    return attachFindInStoreStockistObserver();
  }
  if (type === 'storeLocator') {
    return attachStoreLocatorAppObserver();
  }
};

const updateSearchResults = ({
  results, status, searchInput, emptySearch = false, type,
}) => {
  if (emptySearch) return resetResults({ searchInput, searchTerm: 'Australia', type });

  // console.info('Google Maps geocoded results: ', results);
  if (status !== window?.google.maps.GeocoderStatus.OK) {
    if (status === window?.google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
      // https://developers.google.com/maps/faq?csw=1#usage_apis
      // https://developers.google.com/maps/documentation/geocoding/usage-and-billing#other-usage-limits
      alert("Sorry. It looks like you've made too many requests. Try again in a few minutes.");
    } else {
      alert(status);
    }
  }
  if (status === window?.google.maps.GeocoderStatus.OK) {
    const postalCodeAddress = results[0];
    const { formatted_address: formattedAddress } = postalCodeAddress;
    if (!formattedAddress) return resetResults({ searchInput, searchTerm: 'Australia', type });
    return resetResults({ searchInput, searchTerm: formattedAddress, type });
  }
};

function getReverseGeocodingData(lat, lng, searchInput) {
  // console.info(`Navigator's Geolocated position: lat ${lat} long ${lng}`);
  const geocoder = new window.google.maps.Geocoder();
  const latlng = new window.google.maps.LatLng(lat, lng);

  geocoder.geocode({ location: latlng }, (results, status) => updateSearchResults({
    results,
    status,
    searchInput,
    type: 'pdp',
  }));
}

function createCustomCurrLocationBtn(searchBar, searchInput) {
  // prevents multiple buttons being created on new mutation listeners
  const buttonAlreadyExists = searchBar.nextSibling?.classList.contains(`.${classes.locationBtn}`);
  if (buttonAlreadyExists) return;

  searchBar.insertAdjacentHTML(
    'afterend',
    `<button class="${classes.locationBtn} btn btn--full btn--dark"><span>Use my current location</span></button>`,
  );

  const customUseCurrLocationBtn = document.querySelector(`.${classes.locationBtn}`);

  customUseCurrLocationBtn.addEventListener('click', () => {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function success(pos) {
      const crd = pos.coords;
      getReverseGeocodingData(crd.latitude, crd.longitude, searchInput);
    }

    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  });
}

// Custom find button since we use the .click() on the original stockist button to trigger the search, and there doesn't seem to be a way to prevent the default event or propagation with `submit` or `click` interceptions...
function createCustomFindBtn(searchInput) {
  // prevents multiple buttons being created on new mutation listeners
  const buttonAlreadyExists = searchInput.nextSibling?.classList.contains(`.${classes.findBtn}`);
  if (buttonAlreadyExists) return;

  searchInput.insertAdjacentHTML(
    'afterend',
    `<button class="${classes.findBtn} btn btn--full btn--dark">SEARCH</button>`,
  );
}

function runGeoCoder({ searchInput, value, type }) {
  const emptySearch = !value.trim() || value === 'Australia';
  if (emptySearch) return updateSearchResults({ searchInput, emptySearch, type });

  const getPostcodePrefix = (postcode) => {
    const firstChar = postcode.charAt(0);
    const isPostCode = Number.isNaN(Number(firstChar)) && postcode.trim().length === 4;
    if (isPostCode) return `Postal Code ${postcode}`;
    return postcode;
  };

  const userSearchInput = `${getPostcodePrefix(value)} Australia`;
  // console.info('Prefixed user search input: ', userSearchInput);

  const geocoder = new window.google.maps.Geocoder();
  return geocoder.geocode({ address: userSearchInput, region: 'AU' }, (results, status) => updateSearchResults({
    results,
    status,
    searchInput,
    type,
  }));
}

function geocodeUserQuery({ searchInput, type }) {
  const findButton = document.querySelector(`.${classes.findBtn}`);
  if (findButton) {
    findButton.addEventListener('click', () => {
      const { value } = searchInput;
      runGeoCoder({ searchInput, value, type });
    });
  }

  // keyup > keydown event to prevent repeated calls to runGeoCoder
  // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#special_cases
  searchInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
    }
  });
  searchInput.addEventListener('keyup', (event) => {
    if (event.key === 'Enter') {
      const { value } = event.target;
      runGeoCoder({ searchInput, value, type });
    }
  });
}

function attachFindInStoreStockistObserver() {
  const FindInStoreStockistObserver = new MutationObserver((mutations, mutationInstance) => {
    const searchForm = document.querySelector('form.stockist-search-form');

    // prevents form from reloading on first submission
    // since the form el attached by the stockist app has
    // an empty action attribute which causes a reload
    if (searchForm) {
      searchForm.onsubmit = () => false;
    }

    const listResults = document.querySelectorAll('.stockist-list-result');
    const modalLoaded = document.querySelector('#find-in-store-modal-content');
    const searchBar = document.querySelector('.stockist-query-entry');
    const searchInput = searchBar?.querySelector('input');
    const locationBtnAlreadyExists = document.querySelector(`.${classes.locationBtn}`);
    const findBtnAlreadyExists = document.querySelector(`.${classes.findBtn}`);

    const map = document.querySelector('.stockist-map-google');

    // remove map immediately
    if (map) map.remove();

    // load buttons immediately
    if (modalLoaded && searchInput && !locationBtnAlreadyExists && !findBtnAlreadyExists) {
      createCustomCurrLocationBtn(searchBar, searchInput);
      createCustomFindBtn(searchInput);
      geocodeUserQuery({ searchInput, type: 'pdp' });
    }

    if (listResults.length) {
      // redefine structure as single list items can't achieve the required layout
      // const directions = document.querySelectorAll(
      //   ".stockist-result-directions-link"
      // );

      attachInventoryMessages();

      mutationInstance.disconnect();
    }
  });

  FindInStoreStockistObserver.observe(document, {
    childList: true,
    subtree: true,
  });
}

function getAP21StockData() {
  const variantDomArr = document.querySelectorAll('.variant-input');
  const variantArray = [...variantDomArr]
    .map((variant, idx) => {
      const input = variant.getElementsByTagName('INPUT');
      const inputState = input[0].checked;
      if (inputState) {
        return idx;
      }
    })
    .filter((element) => element !== undefined);

  const variantSkuObj = Object.values(window.inventories);
  const variantSkuArray = Object.values(Object.assign({}, ...variantSkuObj));
  const idx = variantArray[0];
  const { variantSku } = variantSkuArray[idx];

  fetch(`https://${window.location.hostname}/apps/dotapparel21/api-checkStock?sku=${variantSku}`)
    .then((response) => response.json())
    .then((data) => {
      const ap21StoreArray = Object.values(data);

      // console.info('DotApparel21 Check Store API Stores:', ap21StoreArray);

      const ap21Stores = ap21StoreArray[0].map((store) => ({
        name: store.attributes.storeName,
        stock: store.attributes.freeStock,
      }));

      // prevents refetching data on reattachment of mutation observer
      // console.info('Mapped Stores', ap21Stores);
      window.ap21Stores = ap21Stores;

      attachInventoryMessages();
    })
    .catch((error) => {
      console.warn(error);
    });
}

if (currentRoute.pdp && !currentRoute.giftCard) {
  // See https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingResults

  getAP21StockData();
  attachFindInStoreStockistObserver();

  const variantInput = document.querySelectorAll('.variant-input');
  Array.from(variantInput).forEach((input) => {
    input.addEventListener('click', () => {
      getAP21StockData();
    });
  });
}

/*= ===========================================================================
  Listens to resize events and adds .is-mobile class to body
============================================================================== */
function toggleMobileClass() {
  const query = 'only screen and (max-width: 768px)';
  const isMobile = window.matchMedia(query).matches;
  const bodyElem = document.querySelector('body');

  if (isMobile) {
    bodyElem.classList.add('is-mobile');
    return true;
  }
  bodyElem.classList.remove('is-mobile');
  return false;
}

toggleMobileClass(); // on load
window.addEventListener('resize', toggleMobileClass);

/*= ===========================================================================
  Gift Card PDP Custom JS
============================================================================== */
function remainingCharacters(e, counterElem) {
  const { target } = e;

  // getting maxlength
  const maxLength = target.getAttribute('maxlength');

  // counting number of characters
  const currentLength = target.value.length;

  // updating counter value
  counterElem.innerHTML = maxLength - currentLength;
}

document.addEventListener('DOMContentLoaded', () => {
  const messageElem = document.querySelector('[data-gift-card-message]');
  const counterElem = document.querySelector('[data-gift-card-remaining]');
  if (!messageElem || !counterElem) return;

  messageElem.addEventListener('input', (e) => {
    remainingCharacters(e, counterElem);
  });

  if (currentRoute.giftCard) {
    const descriptionTrigger = document.querySelector('[aria-controls^="Product-content-description"');
    descriptionTrigger.click();
  }
});

/*= ===========================================================================
  Read More/Less Custom JS
============================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  const readMoreContainer = document.querySelector('[data-read-more-container]');
  const readMoreTruncated = readMoreContainer.querySelector('[data-read-more-truncated]');
  const readMoreFull = readMoreContainer.querySelector('[data-read-more-full]');
  const readMoreButtons = readMoreContainer.querySelectorAll('[data-read-more-toggle');

  readMoreButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (readMoreTruncated.classList.contains('visually-hidden')) {
        readMoreTruncated.classList.remove('visually-hidden');
        readMoreFull.classList.add('visually-hidden');
      } else {
        readMoreTruncated.classList.add('visually-hidden');
        readMoreFull.classList.remove('visually-hidden');
      }
    });
  });
});

// Listens for addToCart event from covet pics popup
document.addEventListener('addToCart:covetPics', (e) => {
  const product = e?.detail;

  if (product) {
    document.querySelector('covet-pics-popup').closePopup();
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: {
          product,
        },
      }),
    );
  }
});
